import { parseDate } from "../utils";

export function getKeysSeries(header) {
  const [, ...keys] = header.split(/\s+/);
  return keys.map((key) => {
    const chunks = key.split("-").map((item) => {
      return item.toUpperCase();
    });
    return chunks.join("-");
  });
}

export const parseStatsCpuData = (response, beginRange, endRange) => {
  if (!response) {
    return { fields: [], items: [] };
  }
  const [header, ...rows] = response.trim(/\s/).split("\n");
  const [, ...keys] = getKeysSeries(header);
  const keysSeries = ["Average", ...keys];
  const newKeys = ["time", ...keysSeries];

  if (rows.length === 0) {
    return { fields: keysSeries, items: [] };
  }

  const newRows = rows.reduce((acc, value) => {
    const [timeAt, ...attrs] = value.split(/\s+/);
    const time = parseDate(timeAt);
    if (beginRange < time && time < endRange) {
      const item = attrs.reduce(
        (acc, value, index) => {
          acc[newKeys[index + 1]] = value === "n/a" ? null : Number(value);
          return acc;
        },
        { time }
      );
      acc.push(item);
    }
    return acc;
  }, []);

  return { fields: keysSeries, items: newRows };
};
